export const defaultData = {
    seo: {
        title: 'Zusammenarbeit & Konditionen | Nexon Digital Studio',
        description:
            'Shopify Shop erstellen lassen in Deutschland: individuelles Design, saubere Theme-Entwicklung, Performance, SEO-Grundlagen und technische Betreuung.',
    },

    hero: {
        subtitle:
            'Bei Nexon Digital Studio steht eine einfache und verständliche Zusammenarbeit im Mittelpunkt. Wir entwickeln und verbessern Shopify-Shops für kleine Unternehmen, Selbstständige und Online-Händler in Deutschland',
        title: ['Zusammenarbeit', '& Konditionen'],
        text: 'Shopify Entwicklung für kleine Unternehmen in Deutschland.',
        button: 'Anfrage senden',
    },
};

export const conditionsProjectStartData = {
    title: 'Wie ein Shopify-Projekt beginnt',
    titleLines: ['Wie ein', 'Shopify-Projekt', 'beginnt'],
    items: [
        {
            id: 1,
            number: '01',
            text: 'Am Anfang steht eine kurze Analyse Ihrer aktuellen Situation. Dabei klären wir, ob ein neuer Shopify-Shop erstellt werden soll, ob ein bestehender Shopify-Store verbessert werden muss oder ob technische Anpassungen an einem vorhandenen Theme notwendig sind.',
        },
        {
            id: 2,
            number: '02',
            text: 'Wichtig sind dabei vor allem Ihre Produkte, Ihre Zielgruppe, die gewünschte Shop-Struktur und die technischen Anforderungen. Auf dieser Grundlage erhalten Sie eine klare Einschätzung zum möglichen Aufwand und zu den nächsten Schritten.',
        },
    ],
};

export const conditionsProcessData = {
    title: 'Typischer Projektablauf',
    subtitle: 'Ein Shopify-Projekt läuft bei Nexon Digital Studio in klaren Schritten ab.',
    items: [
        {
            id: 1,
            number: '01',
            title: 'Anfrage und Erstkontakt',
            text: 'Sie senden eine Anfrage mit den wichtigsten Informationen zu Ihrem Projekt. Dazu gehören zum Beispiel Ihr aktueller Shop, Ihre Produkte, gewünschte Funktionen oder konkrete Probleme im bestehenden Shopify-Store.',
        },
        {
            id: 2,
            number: '02',
            title: 'Analyse und Einschätzung',
            text: 'Wir prüfen, welche Shopify-Lösung sinnvoll ist und welche technischen Aufgaben notwendig sind. Dabei geht es um Shop-Struktur, Theme-Anpassung, Produktseiten, Collections, mobile Darstellung und grundlegende technische Punkte.',
        },
        {
            id: 3,
            number: '03',
            title: 'Angebot und Vertrag',
            text: 'Sie erhalten ein klares Angebot mit Leistungsumfang. Vor Beginn wird die Zusammenarbeit schriftlich bestätigt und ein Projektvertrag unterschrieben, sodass Aufgaben, Kosten und Zahlungsbedingungen transparent sind.',
        },
        {
            id: 4,
            number: '04',
            title: 'Umsetzung',
            text: 'Nach Freigabe und Vertragsunterzeichnung beginnt die technische Umsetzung. Dazu können Shopify-Einrichtung, Theme-Anpassung, Startseite, Produktseiten, Collection-Seiten, Navigation, mobile Optimierung oder technische Verbesserungen gehören.',
        },
        {
            id: 5,
            number: '05',
            title: 'Prüfung und Anpassungen',
            text: 'Vor dem Launch oder der Übergabe wird der Shopify-Shop geprüft. Dazu gehören Darstellung auf mobilen Geräten, Navigation, technische Funktionalität, grundlegende SEO-Struktur und wichtige Shop-Bereiche.',
        },
        {
            id: 6,
            number: '06',
            title: 'Übergabe oder Launch',
            text: 'Nach Abschluss erhalten Sie den fertigen Shopify-Shop oder die umgesetzten Anpassungen. Je nach Projekt unterstützen wir auch beim Launch und bei letzten technischen Schritten.',
        },
        {
            id: 7,
            number: '07',
            title: 'Unterstützung nach dem Start',
            text: 'Auch nach dem Launch können weitere Anpassungen, technische Verbesserungen oder Support-Leistungen vereinbart werden.',
        },
    ],
};

export const conditionsScopeData = {
    title: 'Was im Projekt enthalten sein kann',
    subtitle:
        'Der genaue Leistungsumfang hängt vom jeweiligen Shopify-Projekt ab. Typische Leistungen sind:',
    services: [
        {
            id: 1,
            title: 'Shopify Shop Erstellung',
        },
        {
            id: 2,
            title: 'technische Shopify-Umsetzung',
        },
        {
            id: 3,
            title: 'Shopify Theme-Anpassung',
        },
        {
            id: 4,
            title: 'Anpassung von Shopify Dawn',
        },
        {
            id: 5,
            title: 'Startseiten für Shopify-Shops',
        },
        {
            id: 6,
            title: 'Shopify Einrichtung',
        },
        {
            id: 7,
            title: 'Shopify Relaunch',
        },
        {
            id: 8,
            title: 'Produktseiten und Collection-Seiten',
        },
        {
            id: 9,
            title: 'Shopify Migration',
        },
        {
            id: 10,
            title: 'Mobile Optimierung von Shopify-Stores',
        },
        {
            id: 11,
            title: 'Grundlegende technische SEO-Struktur',
        },
        {
            id: 12,
            title: 'Unterstützung nach dem Launch',
        },
    ],
    note: 'Nicht jedes Projekt benötigt alle Leistungen. Deshalb wird der Umfang vor Beginn klar definiert und im Angebot sowie im Projektvertrag festgehalten.',
};

export const conditionsExcludedData = {
    title: 'Was nicht automatisch enthalten ist',
    subtitle:
        'Damit die Zusammenarbeit transparent bleibt, wird auch klar festgelegt, welche Leistungen nicht automatisch enthalten sind.',
    intro: 'Dazu können gehören:',
    groups: [
        {
            id: 1,
            items: [
                'Professionelle Produktfotos',
                'Texte und Übersetzungen',
                'Logo-Design oder vollständige Markenentwicklung',
            ],
        },
        {
            id: 2,
            items: [
                'Shopify-Abonnement',
                'Kostenpflichtige Shopify-Apps',
                'Externe Tools und Softwarekosten',
            ],
        },
        {
            id: 3,
            items: [
                'laufende Wartung nach Projektabschluss',
                'umfangreiche SEO-Betreuung nach dem Launch',
            ],
        },
        {
            id: 4,
            items: [
                'rechtliche Texte wie Impressum, Datenschutz oder AGB',
                'bezahlte Werbung oder Marketing-Kampagnen',
            ],
        },
    ],
    note: 'Diese Leistungen können bei Bedarf besprochen werden, sind aber nicht automatisch Teil jedes Shopify-Projekts. Falls zusätzliche Leistungen gewünscht sind, werden sie separat vereinbart.',
};

export const conditionsPricingData = {
    title: 'Preise und Zahlung',
    items: [
        {
            id: 1,
            title: 'Individueller Preis',
            text: 'Die Kosten hängen vom Umfang des Shopify-Projekts ab. Ein einfacher Shopify-Shop, eine Theme-Anpassung oder ein Relaunch unterscheiden sich deutlich im Aufwand.',
        },
        {
            id: 2,
            title: 'Klares Angebot vor Beginn',
            text: 'Vor Projektbeginn erhalten Sie ein Angebot mit klarem Leistungsumfang. Darin wird festgelegt, welche Aufgaben umgesetzt werden, welche Kosten entstehen und welche nächsten Schritte geplant sind.',
        },
        {
            id: 3,
            title: 'Zahlungsbedingungen im Projektvertrag',
            text: 'Die Zahlungsbedingungen werden vor Projektbeginn schriftlich festgehalten. Je nach Umfang kann eine Anzahlung vor Beginn der Umsetzung vereinbart werden. Weitere Zahlungen, Fristen und Leistungen werden im Angebot oder im Projektvertrag transparent definiert.',
        },
    ],
    note: 'Nexon Digital Studio ist geeignet für kleine Unternehmen, Selbstständige und Online-Händler in Deutschland, die Shopify gezielt für den Online-Verkauf nutzen möchten.',
};

export const conditionsCommunicationData = {
    title: 'Kommunikation während des Projekts',
    titleLines: ['Kommunikation', 'während des', 'Projekts'],
    items: [
        {
            id: 1,
            number: '01',
            text: 'Eine klare Kommunikation ist besonders wichtig. Deshalb arbeiten wir mit festen Abstimmungen und verständlichen Rückmeldungen.',
        },
        {
            id: 2,
            number: '02',
            text: 'Die Kommunikation erfolgt je nach Projekt per E-Mail, Telefon oder Online-Meeting. Ziel ist, Entscheidungen schnell zu treffen und den Projektablauf übersichtlich zu halten.',
        },
        {
            id: 3,
            number: '03',
            text: 'Sie erhalten keine unnötig komplizierten technischen Erklärungen, sondern klare Informationen darüber, was umgesetzt wird, warum es sinnvoll ist und welche nächsten Schritte folgen.',
        },
    ],
};

export const conditionsMailData = {
    title: ['Lassen Sie uns über Ihr', 'Shopify-Projekt sprechen'],
    text: 'Wenn Sie einen neuen Shopify-Shop planen oder Ihren bestehenden Shopify-Store verbessern möchten, können Sie uns eine Anfrage senden. Wir prüfen gemeinsam, welche Lösung sinnvoll ist und welche nächsten Schritte zu Ihrem Projekt passen.',
    placeholder: 'Ihre E-Mail-Adresse',
    button: 'Anfrage senden',
    messages: {
        emptyEmail: 'Bitte geben Sie Ihre E-Mail-Adresse ein.',
        invalidEmail: 'Bitte geben Sie eine gültige E-Mail-Adresse ein.',
        error: 'Beim Senden ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.',
        success: 'Vielen Dank! Ihre Anfrage wurde erfolgreich gesendet.',
    },
};
